/* Confirmation page shown after a particulier successfully submits a listing. */
import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { CheckCircle2, Clock, ArrowRight, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useSeo } from "../../lib/useSeo";
import { Button } from "../../components/ui/button";

const VerkoopSubmitted = () => {
  useSeo({ title: "Advertentie ingediend · WoningAlert" });
  const { lid } = useParams();
  const navigate = useNavigate();
  const [l, setL] = useState(null);

  useEffect(() => {
    api(`/particulier/sale-listings/${lid}`).then(setL).catch(() => navigate("/mijn-woning-verkopen"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lid]);

  if (!l) return <div className="flex min-h-[50vh] items-center justify-center"><Loader2 className="animate-spin text-brandblue" /></div>;

  const title = l.title || `${l.street || ""} ${l.house_number || ""}`.trim() || "Je woning";

  return (
    <div className="mx-auto max-w-xl px-4 py-16 text-center sm:px-6">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-success/15 text-success">
        <CheckCircle2 size={34} />
      </div>
      <h1 className="mt-6 font-display text-3xl font-extrabold text-navy" data-testid="submitted-title">
        Je woning is ingediend!
      </h1>
      <p className="mt-3 text-slate-500">
        We controleren je advertentie voordat deze op WoningAlert verschijnt.
        Zodra je woning is goedgekeurd, laten we je dit weten.
      </p>

      <div className="mt-8 overflow-hidden rounded-3xl border border-border bg-white text-left shadow-sm">
        {l.image || (l.gallery && l.gallery[0]) ? (
          <img src={l.image || l.gallery[0]} alt="" className="h-48 w-full object-cover" />
        ) : null}
        <div className="p-5">
          <div className="flex items-center gap-2">
            <h2 className="truncate font-display text-lg font-bold text-navy">{title}</h2>
          </div>
          <div className="text-sm text-slate-500">{[l.street, l.house_number].filter(Boolean).join(" ")} · {l.city}</div>
          <div className="mt-3 flex items-center gap-2 rounded-full bg-amber-100 px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-amber-800 w-fit">
            <Clock size={13} /> Wacht op goedkeuring
          </div>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button asChild variant="outline" className="rounded-xl">
          <Link to="/mijn-woning-verkopen">Naar mijn advertenties</Link>
        </Button>
        <Button asChild className="rounded-xl bg-brandblue hover:bg-brandblue/90">
          <Link to="/">Terug naar home <ArrowRight size={14} className="ml-1.5" /></Link>
        </Button>
      </div>
    </div>
  );
};

export default VerkoopSubmitted;
